/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Homepage_TitleInputs */

const en_meta_homepage_title = /** @type {(inputs: Meta_Homepage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening - Text to Speech for Academic Papers and Research Papers`)
};

const es_meta_homepage_title = /** @type {(inputs: Meta_Homepage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening - Texto a voz para artículos académicos y de investigación`)
};

/**
* | output |
* | --- |
* | "Listening - Text to Speech for Academic Papers and Research Papers" |
*
* @param {Meta_Homepage_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_homepage_title = /** @type {((inputs?: Meta_Homepage_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Homepage_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_homepage_title(inputs)
	return en_meta_homepage_title(inputs)
});